import { BASE } from "@/api/index";
import axios from "@/api/http";

const BASE_URL = BASE.PRO1;

/**
 * 总控-城市仓推广奖励结算
 * @param {*} params
 * @returns
 */
export function postSettlementLogisticsPromotionList(params = {}) {
  return axios.post(`${BASE_URL}/settlement/logistics/promotion/list`, params);
}

/**
 * 总控-供应商推广奖励结算
 * @param {*} params
 * @returns
 */
export function postSettlementSupplierPromotionList(params = {}) {
  return axios.post(`${BASE_URL}/settlement/supplier/promotion/list`, params);
}

/**
 * 总控-推广奖励明细
 * @param {*} params
 * @returns
 */
export function postSettlementOrderPromotionList(params = {}) {
  return axios.post(`${BASE_URL}/settlement/order/promotion/list`, params);
}
